import { render, staticRenderFns } from "./InviteFriendsShareSocialLinks.vue?vue&type=template&id=6cdbc819&"
import script from "./InviteFriendsShareSocialLinks.vue?vue&type=script&lang=js&"
export * from "./InviteFriendsShareSocialLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports